<template>
    <paginate
        v-bind="$props"
        :page-count="pageCount"
        prev-text="<i style='line-height: 0; font-size: 20px' class='vs-icon notranslate icon-scale material-icons null'>chevron_left</i>"
        next-text="<i style='line-height: 0; font-size: 20px' class='vs-icon notranslate icon-scale material-icons null'>chevron_right</i>"
        :container-class="'pagination'"
        v-model="currentPage" />
</template>

<script>
import Paginate from "vuejs-paginate";

export default {
    name: "pagination",

    components: { Paginate },

    props: {
        page: Number,
        pageCount: Number,
    },

    data() {
        return {
            currentPage: this.page || 1,
        };
    },

    watch: {
        currentPage() {
            this.$emit("input", this.currentPage);
            this.$emit("change", { currentPage: this.currentPage });
        },

        page() {
            this.currentPage = this.page;
        }
    },

    methods: {},
};
</script>

<style lang="scss">
.pagination {
    display: flex;
    align-items: center;

    li {
        margin-left: 4px;

        a {
            width: 35px;
            height: 35px;
            font-size: 14px;
            font-weight: 500;

            min-width: 25px;
            min-height: 25px;

            display: flex;
            align-items: center;
            justify-content: center;

            color: var(--vs-hex-gray);
            background-color: rgba($color: #efefef, $alpha: 0.8);
            color: var(--vs-hex-gray);

            border-radius: 50%;
        }

        &:disabled {
            opacity: 0.5;
        }

        &.active {
            & > a {
                background: var(--vs-hex-primary);
                color: var(--vs-hex-white);
            }
        }

        &:first-child {
            margin-right: 8px;
            line-height: 0;
        }

        &:last-child {
            margin-left: 8px;
            line-height: 0;
        }
    }
}

@media screen and (max-width: 410px) {
    .pagination {
        li {
            a {
                width: 30px;
                height: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination/Pagination.vue